import React, { useContext, useEffect, useRef, useState } from 'react';

import { CoachmarkContext } from '@context/coachmark';
import useLayout from '@context/layout/useLayout';

import { bool } from 'prop-types';
import BottomPanelToolbar from './BottomPanelToolbar';
import BottomPanelSectionTab from './BottomPanelSectionTab';
import { BOTTOM_TAB } from './constant';
import { styBottomPanel, styBottomPanelWrapper } from './style';
import useEventTracker from './tracker/useEventTracker';

const BottomPanel = ({ withBottomPanel }) => {
  const { rightPanel, bottomPanel, tradePanel, refs } = useLayout();
  const { eventSwitchBottomPanel, eventSwitchAccountType } = useEventTracker();

  const styProps = {
    isRightPanelVisible: rightPanel.isVisible,
    isTradePanelVisible: tradePanel.isVisible,
    isBottomPanelNormal: bottomPanel.isNormal,
    isBottomPanelCollapsed: bottomPanel.isCollapsed,
    isBottomPanelExpand: bottomPanel.isExpand,
    withBottomPanel,
  };

  const [instrumentTab, setInstrumentTab] = useState(BOTTOM_TAB[0]);
  const [sectionTab, setSectionTab] = useState(instrumentTab.tableTab[0]);
  const [activePills, setActivePills] = useState(sectionTab.pills[0]);

  const TableContent = activePills?.tableContent;

  const eventProps = {
    instrument: instrumentTab.name,
    bottompanel_tab_header_2: sectionTab?.name,
  };

  useEffect(() => {
    eventSwitchBottomPanel(eventProps);
  }, [instrumentTab, sectionTab]);

  useEffect(() => {
    if (!withBottomPanel) {
      bottomPanel.collapse();
    }
  }, [withBottomPanel]);

  const bottomPanelRefs = useRef(null);
  const { setCoachmarkRefs } = useContext(CoachmarkContext);
  useEffect(() => {
    if (!bottomPanelRefs.current) {
      return;
    }
    setTimeout(() => {
      // Bottom panel element is not placed correctly on first render. Offset using 200ms timeout
      setCoachmarkRefs({ coachmarkStock: { bottomPanel: bottomPanelRefs } });
    }, 200);
  }, [bottomPanelRefs]);

  return (
    <div className={styBottomPanel(styProps)} ref={bottomPanelRefs}>
      {/* Require this wrapper because of absolute parent */}
      <div className={styBottomPanelWrapper}>
        <BottomPanelToolbar
          instrumentTab={instrumentTab}
          setInstrumentTab={(tab) => {
            setInstrumentTab(tab);
            setSectionTab(tab.tableTab[0]);
            setActivePills(tab.tableTab[0].pills[0]);
          }}
        />

        {(bottomPanel.isNormal || bottomPanel.isExpand) && (
          <>
            <BottomPanelSectionTab
              instrumentTab={instrumentTab}
              sectionTab={sectionTab}
              setSectionTab={(tab) => {
                setSectionTab(tab);
                setActivePills(tab.pills[0]);
              }}
              activePills={activePills}
              setActivePills={(item) => {
                setActivePills(item);
                eventSwitchAccountType(item.label);
              }}
            />
            {TableContent && <TableContent ref={refs.current.bottomPanelTable} />}
          </>
        )}
      </div>
    </div>
  );
};

BottomPanel.propTypes = {
  withBottomPanel: bool,
};

BottomPanel.defaultProps = {
  withBottomPanel: true,
};

export default BottomPanel;
